import type { Item, ArticleTextType } from '../../types';

export const isArticleText = (item: Item): item is ArticleTextType => {
	return !!(item && item.__typename === 'Article_Text');
};
